import '@vfde-brix/tooltip/dist/styles.css';
import { createTooltipComponent } from '@vfde-brix/tooltip';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/core';
import { createComponents } from '../../utils/initComponents';

createComponents('brix-tooltip', createTooltipComponent, NO_PATTERN_BUSINESS_LOGIC);
